import { defineAsyncComponent } from 'vue';

export const LazyCollectionFieldSelect = defineAsyncComponent(() => import('./Collection/CollectionFieldSelect.vue'));
export const LazyCollectionSelect = defineAsyncComponent(() => import('./Collection/CollectionSelect.vue'));
